import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Products API
export const productsAPI = {
  getAll: (category = null) => {
    const params = category && category !== 'all' ? { category } : {};
    return api.get('/products', { params });
  },
  getById: (id) => api.get(`/products/${id}`),
  create: (product) => api.post('/products', product),
  update: (id, product) => api.put(`/products/${id}`, product),
  delete: (id) => api.delete(`/products/${id}`),
};

// Cart API
export const cartAPI = {
  get: (sessionId) => api.get(`/cart/${sessionId}`),
  addItem: (sessionId, item) => api.post(`/cart/${sessionId}/add`, item),
  updateItem: (sessionId, item) => api.put(`/cart/${sessionId}/update`, item),
  removeItem: (sessionId, productId) => api.delete(`/cart/${sessionId}/remove/${productId}`),
  clear: (sessionId) => api.delete(`/cart/${sessionId}/clear`),
};

// Orders API
export const ordersAPI = {
  createPaymentIntent: (amount) => api.post('/orders/create-payment-intent', null, { params: { amount } }),
  create: (order) => api.post('/orders', order),
  getAll: (status = null) => {
    const params = status ? { status } : {};
    return api.get('/orders', { params });
  },
  getById: (id) => api.get(`/orders/${id}`),
  getByEmail: (email) => api.get(`/orders/email/${email}`),
  updateStatus: (id, status) => api.put(`/orders/${id}/status`, null, { params: { status } }),
};

// Contact API
export const contactAPI = {
  submit: (data) => api.post('/contact', data),
  getAll: (read = null) => {
    const params = read !== null ? { read } : {};
    return api.get('/contact', { params });
  },
  markAsRead: (id) => api.put(`/contact/${id}/read`),
  delete: (id) => api.delete(`/contact/${id}`),
};

// Bookings API
export const bookingsAPI = {
  create: (booking) => api.post('/bookings', booking),
  getAll: (status = null) => {
    const params = status ? { status } : {};
    return api.get('/bookings', { params });
  },
  getById: (id) => api.get(`/bookings/${id}`),
  updateStatus: (id, status) => api.put(`/bookings/${id}/status`, null, { params: { status } }),
  delete: (id) => api.delete(`/bookings/${id}`),
};

// Services API
export const servicesAPI = {
  getAll: () => api.get('/services'),
};

// Health check
export const healthAPI = {
  check: () => api.get('/health'),
};

export default api;
